// Define an enum with string literal values
enum PricingTypeEnum {
  ServicePrice = "service_price",
  CustomPrice = "custom_price",
  PercentageDiscount = "percentage_discount",
  Free = "free",
}
// Create a constant array to define the PricingOptionType
const PricingTypes: { value: string; label: string }[] = [
  { value: PricingTypeEnum.Free, label: "مجاناً" },
  { value: PricingTypeEnum.CustomPrice, label: "سعر مخصص" },
  { value: PricingTypeEnum.PercentageDiscount, label: "نسبة الخصم" },
  { value: PricingTypeEnum.ServicePrice, label: "سعر الخدمة" },
];

export { PricingTypeEnum, PricingTypes };
